const STORAGE_KEY = "mayker_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export const captureAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((key) => {
    const v = params.get(key);
    if (v) found[key] = v.trim().slice(0, 255);
  });
  if (found.gclid) {
    if (!found.utm_source) found.utm_source = "google";
    if (!found.utm_medium) found.utm_medium = "cpc";
  }
  if (Object.keys(found).length === 0) return;
  found.landing_page = window.location.origin + window.location.pathname;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
  } catch {
    // storage unavailable (private mode) — attribution simply won't persist
  }
};

export const getAttribution = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

export const getAttributionFields = () =>
  Object.entries(getAttribution()).map(([name, value]) => ({ objectTypeId: "0-1", name, value }));
